import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../view/Login.vue';
import Dashboard from '../view/Dashboard';
import Helpers from '../helpers/index';


Vue.use(VueRouter);

const Routes = {
    mode: 'history',
    base: 'fortress-admin',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'index',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'Home']
            }
        },
        {
            path: '/dashboard/property-owners',
            name: 'property-owners',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'Property Owners']
            }
        },
        {
            path: '/dashboard/user/profile/:type/:userId',
            name: 'view-user-profile',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'User', 'Profile']
            }
        },
        {
            path: '/dashboard/property-owners/property/:ownerId',
            name: 'property-owners-view',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'Property Owner', 'Properties']
            }
        },
        {
            path: '/dashboard/property-owners/property/sub-admin/:estateId',
            name: 'property-owners-sub-admin',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'Properties', 'SubAdmin']
            }
        },
        {
            path: '/dashboard/property-owners/property/residents',
            name: 'property-residents-all',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'All Residents']
            }
        },
        {
            path: '/dashboard/property-owners/property/residents/:estateId',
            name: 'property-owners-residents',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'Property', 'Residents']
            }
        },
        {
            path: '/dashboard/property-manager',
            name: 'property-manager',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'Property Manager']
            }
        },
        {
            path: '/dashboard/property-residents',
            name: 'property-residents',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                breadcrumb: ['Dashboard', 'Property Residents']
            }
        },
    ]
}

const router = new VueRouter(Routes);

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!Helpers.isAuthenticated()) {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        } else {
          next();
        }
      } else if(Helpers.isAuthenticated()) {
        next({
            path: '/dashboard',
          });
      }
      else {
        next();
    }
});


export default router;
